<template>
    <div v-if="showToast" class="toast" >
      <p>{{ toastTitle }}</p>
    </div>
</template>

<script>
export default {
  data: () => ({
    showToast: false,
    toastTitle: '',
  }),
  
  methods: {
    show (params) {
        this.toastTitle = params;
        this.showToast = true
    },

  },
  watch: {
    toastTitle: function(val) {
        if (val) {
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
            this.toastTitle='';
          }, 3000)
        }
        return val;
      }
  }
}
</script>

<style scoped>  
.toast {
  	position: fixed;
  	top: 50%;
  	left: 50%;
  	transform: translate(-50%, -50%);
  	background: rgba(49, 49, 49, 0.8);
  	color: #fff;
  	border-radius: 10px;
  	z-index: 9999;
	padding:10px 20px;
	font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/index.vue